import { config } from "../config/config";
import { ChangePassword, LoginCredentials, User } from "../types/auth";
import {
  setAuthToken,
  getAuthToken,
  clearAuthToken,
} from "../services/tokenService.service";

export const authService = {
  login: async (credentials: LoginCredentials): Promise<User> => {
    try {
      const response = await fetch(`${config.baseURL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      });

      if (!response.ok) {
        throw new Error("Login failed");
      }

      const data = await response.json();

      setAuthToken(data.data.token);
      localStorage.setItem("user", JSON.stringify(data.data.user));

      return {
        id: data.data.user.id,
        email: data.data.user.email,
        name: data.data.user.name,
      };
    } catch (error) {
      console.error("Error during login:", error);
      throw error;
    }
  },

  logout: async (): Promise<void> => {
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Token not found. Please login first.");

      const response = await fetch(`${config.baseURL}/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Logout failed");
      }

      clearAuthToken();
      localStorage.removeItem("user");
    } catch (error) {
      console.error("Error during logout:", error);
      throw error;
    }
  },

  changePassword: async (payload: ChangePassword): Promise<void> => {
    try {
      const token = getAuthToken();
      if (!token) throw new Error("Token not found. Please login first.");

      const response = await fetch(`${config.baseURL}/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Change password failed");
      }
    } catch (error) {
      console.error("Error during change password:", error);
      throw error;
    }
  },

  checkToken: async (): Promise<boolean> => {
    try {
      const token = getAuthToken();
      const response = await fetch(`${config.baseURL}/check-token`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      return data.status === 200;
    } catch (error) {
      console.error("Error during token validation:", error);
      return false;
    }
  },
};
